import { Box, Dialog, IconButton, Slide, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import { forwardRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Cookies from 'universal-cookie';

const ExoDialog = ({
  children,
  open,
  z = '50',
  onClose,
  className,
  limitWidth,
  maxWidth = '800px',
  noBlur,
  actions,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const cookies = new Cookies();
  const isLowPerformance = cookies.get('isLowPerformance') === 'true';

  return (
    <Dialog
      open={Boolean(open)}
      TransitionComponent={Transition}
      fullScreen
      className="no-nav"
      sx={{
        '& .MuiPaper-root': {
          bgcolor: 'transparent',
          backgroundImage: 'none',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        },
        '.MuiBackdrop-root': {
          backdropFilter: noBlur ? 'none' : '',
          bgcolor:
            noBlur || isLowPerformance ? colors.glassSolid : colors.glass,
        },
      }}
    >
      {(onClose || actions) && (
        <Box
          sx={{ bgcolor: colors.card }}
          className="px-4 py-2 flex flex-row-reverse gap-1"
        >
          {onClose && (
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
          {actions}
        </Box>
      )}
      <Box
        sx={{
          height: onClose ? 'calc(100% - 53px)' : '100%',
          maxWidth: limitWidth ? maxWidth : 'auto',
          margin: 'auto',
        }}
        className={'p-2 w-full relative ' + className}
      >
        {children}
      </Box>
    </Dialog>
  );
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default ExoDialog;
